var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFaqCross(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    clipPath: "url(#clip0_801_9065)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16.0018,
    height: 2.00112,
    rx: 1.00056,
    transform: "matrix(0.70595 0.708262 -0.70595 0.708262 6.3533 5.25781)",
    fill: "#0A0A0C"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.00112,
    height: 16.0018,
    rx: 1.00056,
    transform: "matrix(0.70595 0.708262 -0.70595 0.708262 16.2371 5.25781)",
    fill: "#0A0A0C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_801_9065"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.9757,
    height: 16,
    fill: "white",
    transform: "matrix(0.70595 0.708262 -0.70595 0.708262 11.2952 0.299805)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaqCross);
export default __webpack_public_path__ + "static/media/faq_cross.3c5315efd2ea95233ba73cd606631cc6.svg";
export { ForwardRef as ReactComponent };